import moment from "moment";

export const getScheduledNotificationId = notification =>
    notification?.message?.notification_id || notification?.notification_id || '';

export const getScheduledNotificationRecipientIds = notification => {
    if (Array.isArray(notification?.userIds)) {
        return notification.userIds;
    }

    if (Array.isArray(notification?.message?.userIds)) {
        return notification.message.userIds;
    }

    return [];
};

export const getScheduledRecipientOptions = (notification, userOptionsById) => (
    getScheduledNotificationRecipientIds(notification).map(id => (
        userOptionsById[String(id)] || {
            value: id,
            label: `Usuari ${id}`,
            color: 'red',
        }
    ))
);

export const getUpcomingScheduledNotifications = (notifications, now=new Date()) => (
    (Array.isArray(notifications) ? notifications : [])
        .filter(notification => moment(notification?.scheduledTime).isAfter(moment(now)))
        .sort((a, b) => moment(a.scheduledTime) - moment(b.scheduledTime))
);

export const toDateTimeLocalInputValue = scheduledTime => (
    scheduledTime ? moment(scheduledTime).format('YYYY-MM-DDTHH:mm') : ''
);

export const formatScheduledNotificationTime = (notification, now=moment()) => {
    const scheduledTime = moment(notification.scheduledTime);
    const diff = scheduledTime.diff(now);
    const duration = moment.duration(diff);
    const seconds = duration.seconds();
    const minutes = duration.minutes();
    const hours = duration.hours();
    const afterToday = moment(scheduledTime).diff(now, 'hours') > 24;
    const hourFormat = scheduledTime.format('HH:mm');
    const standardFormat = scheduledTime.format('HH:mm DD/MM/YYYY');

    if (afterToday) return standardFormat;
    if (hours === 0 && minutes === 0) return `En ${seconds} segons (${hourFormat})`;
    if (hours === 0 && minutes === 1) return `En 1 minut i ${seconds} segons (${hourFormat})`;
    if (hours === 0 && minutes < 60) return `En ${minutes} minuts (${hourFormat})`;
    if (hours === 1) return `En 1 hora i ${minutes} minuts (${hourFormat})`;
    if (hours < 24) return `En ${hours} hores i ${minutes} minuts (${hourFormat})`;
    return standardFormat;
};

export const formatScheduledNotificationText = (text, id, castellersInfo) => {
    const info = castellersInfo[id] || {};
    const nom = info.nom || '';
    const cognom = info.cognom || info['primer-cognom'] || '';
    const sobrenom = info.mote ? info.mote :
        info.nom ? info.nom :
        '';

    return (text || '')
        .replaceAll(' {nom}', nom !== '' ? ` ${nom}` : '')
        .replaceAll('{nom}', nom !== '' ? nom : '')
        .replaceAll(' {cognom}', cognom !== '' ? ` ${cognom}` : '')
        .replaceAll('{cognom}', cognom !== '' ? cognom : '')
        .replaceAll(' {sobrenom}', sobrenom !== '' ? ` ${sobrenom}` : '')
        .replaceAll('{sobrenom}', sobrenom !== '' ? sobrenom : '');
};

export const formatSelectedDay = notification => {
    const selectedDay = notification?.message?.data?.selectedDay;
    if (!selectedDay) return '-';

    const [day, month, year] = selectedDay.split('-');
    const formattedDay = day.padStart(2, '0');
    const formattedMonth = (parseInt(month) + 1).toString().padStart(2, '0');

    return `${formattedDay}/${formattedMonth}/${year}`;
};

export const buildScheduledNotificationUpdate = ({ notification, title, body, scheduledDateTime, recipients }) => {
    const notificationId = getScheduledNotificationId(notification);
    const scheduledTime = new Date(scheduledDateTime);

    if (!notificationId) {
        throw new Error('No es pot editar una notificació sense identificador.');
    }

    if (Number.isNaN(scheduledTime.getTime())) {
        throw new Error('La data programada no és vàlida.');
    }

    const userIds = (recipients || []).map(user => user.value);

    if (userIds.length === 0) {
        throw new Error('Cal seleccionar com a mínim un destinatari.');
    }

    const message = {
        ...notification.message,
        title,
        body,
        notification_id: notificationId,
        userIds,
        data: {
            ...notification.message?.data,
            notification_id: notificationId,
        },
    };

    return {
        scheduledTime: scheduledTime.toISOString(),
        message,
        userIds,
    };
};
